// Texty modelu blogu (blogModel.js) — sdílené articlesPage.js a articleDetail.js.
import { plural } from '../plural.js';

export default {
  /** 1 článek / 2–4 články / 5+ článků */
  articlesWord: (n) => plural(n, ['článek', 'články', 'článků']),
  /** doba čtení, dlouhý tvar (hero, detail): „5 min čtení" */
  readMinutesSuffix: ' min čtení',
  /** krátký tvar pro karty mřížky: „5 min" */
  readShortSuffix: ' min',
};
